/** path เมนูส่งพัสดุ — ใช้ร่วมกับ routesConfig และ navigate */
export const MANAGE_PARCEL_LIST_PATH = "/manage-parcel";
export const MANAGE_PARCEL_CREATE_PATH = "/manage-parcel/create";
